import React from 'react';

interface Props {
  data: {
    label: string;
    value: string | number | React.ReactNode;
    render?: React.ReactNode;
  }[];
  tableStyle?: React.CSSProperties;
  thStyle?: React.CSSProperties;
  tdStyle?: React.CSSProperties;
}
const TwoColumnsText = (props: Props): JSX.Element => {
  return (
    <table style={props.tableStyle}>
      <tbody>
        {props.data.map((row) => (
          <tr key={row.label}>
            <th
              align="left"
              style={{ paddingLeft: 0, padding: '5px 0', ...props.thStyle }}
            >
              {row.label}:
            </th>
            <td style={props.tdStyle}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TwoColumnsText;
